import DirectorConsole from "@/components/landing/DirectorConsole";
import type { ConsoleToolId } from "@/components/landing/ToolCompass";

// DirectorWorkspace — just the Director console, full width.
//
// Which tool the whole page IS gets picked by the COMPASS at the top of the
// page (2026-07-22); that choice is threaded straight into the console so its
// chat + storyboard board reflect only that tool — there is no second tool
// picker inside the chat anymore.
//
// Only the console tools reach it (2026-09-24): the compass's welcome and
// storybook stops have no console, and HeroSection keeps passing the last
// console tool while one of those is showing, with visible={false}.

export default function DirectorWorkspace({ tool, visible = true }: { tool?: ConsoleToolId; visible?: boolean }) {
  return (
    <div data-testid="director-workspace" className="min-w-0">
      <DirectorConsole tool={tool} visible={visible} />
    </div>
  );
}
